import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { DTFService } from "../../dtf.service";
import { AuthorizationService } from "../authorization/authorization.service";
import { WindowRef } from '../../utils/window';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { TranslateUtil } from '../../utils/translate-util';
import { SharedTranslateModule } from "../../utils/sharedTranslateModule";
import { SessionTimeoutComponent } from "../sessionTimeout/sessionTimeout.component";


@Component({
  selector: "div.dtf-brochures",
  imports: [SharedTranslateModule, SessionTimeoutComponent],
  templateUrl: './brochures.component.html',
  providers: [
    //  ClassesUtil, WindowRef
  ]
})
export class DTFBrochuresComponent implements OnInit {
  router: Router;
  isCanadaPortal = false;
  isFrench = false;
  currentCountry: string;
  language = '';
  targetRedirect = '';
  usUrl: string;
  caUrl: string;

  constructor(
    router: Router,
    public translate: TranslateService,
    private _window: WindowRef,
    public translateUtil: TranslateUtil
  ) {
    this.router = router;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
  }
  ngOnInit() {
    const language = (window as any).mbfs.language;
    this.isFrench = ('fr-CA' === language) ? true : false; //checks if language is french or english for Canada
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
    });
  }

  openBrochure(pdfPath: string): void {
    this.enableGA(
      'true',
      pdfPath
    );
  }

  enableGA(toggle: string, page: string): void {
    this.translate.get('LoginModal.GARedirect').subscribe((data: any) => {
      const redirect = this.usUrl + data + toggle + '&page=' + encodeURIComponent(page);

      window.open(redirect, '_blank');
    });
  }
}
